import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";

export function useAccess() {
  const { data } = useQuery({ queryKey: ["my-access"], queryFn: () => get("/my/access") });
  const acc = data || { all: false, category_ids: [], exam_ids: [], test_ids: [] };
  return {
    loaded: !!data,
    hasCategory: (cid) => acc.all || acc.category_ids.includes(cid),
    canTest: (t) => t.is_free || acc.all || acc.test_ids.includes(t.id) || acc.exam_ids.includes(t.exam_id),
  };
}
